import React from 'react';
import { projects } from '../../data/portfolio';
import './ProjectSection.css';

function ProjectSection() {
  return (
    <section id="projects" className="projects-section" aria-labelledby="projects-title">
      <div className="section-heading">
        <p>Projects</p>
        <h2 id="projects-title">프로젝트</h2>
      </div>

      <article className="featured-project">
        <div className="featured-project-meta">
          <p>Featured project</p>
          <span>{projects.featured.context}</span>
        </div>
        <div className="featured-project-body">
          <h3>{projects.featured.title}</h3>
          <p>{projects.featured.description}</p>
          <ul>
            {projects.featured.details.map((detail) => <li key={detail}>{detail}</li>)}
          </ul>
          <small>{projects.featured.technologies.join(' · ')}</small>
          <a
            href={projects.featured.href}
            target="_blank"
            rel="noreferrer"
            aria-label="토파고 서비스 보기"
          >
            서비스 보기 <span aria-hidden="true">↗</span>
          </a>
        </div>
      </article>

      <div className="team-projects">
        {projects.team.map((project) => (
          <article className="project-entry" key={project.id}>
            <div className="project-meta">
              <p>{project.period}</p>
              <span>Team project</span>
            </div>
            <div className="project-body">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <small>{project.technologies.join(' · ')}</small>
              <a href={project.href} target="_blank" rel="noreferrer" aria-label={`${project.title} GitHub`}>
                GitHub <span aria-hidden="true">↗</span>
              </a>
            </div>
          </article>
        ))}
      </div>

      <div className="outside-work">
        <div className="outside-heading">
          <p>게임과 새로운 상호작용 방식을 탐구하는 개인 작업입니다.</p>
          <h3>Outside Work</h3>
        </div>
        <div className="outside-list">
          {projects.outside.map((project) => (
            <a key={project.id} href={project.href} target="_blank" rel="noreferrer">
              <strong>{project.title}</strong>
              <span>{project.description}</span>
              <i aria-hidden="true">↗</i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProjectSection;
